import { useEffect, useRef, useState } from 'react';
import { useSearchStore } from '../../../store/store';
import { getAgentBreakdown } from '../../../service/proficiency-metrics';
import { setStateData } from '../../../common/helpers/state';

export function useBreakdownTable({ parameterName, pathname, isOfficeListBreakdown, setAgentData }) {
    const [state, setState] = useState({
        data: { results: [], totals: {}, error: null },
        isLoading: false,
        isOfficeListBreakdown,
    });

    const {
        search,
        selectedBreakdownOffice,
        selectedModule,
        setIsFooterDisabled,
        selectedBreakdownTab,
    } = useSearchStore((state) => {
        const { [state.selectedModule]: moduleState } = state;
        const { breakdowns = {} } = moduleState;
        return ({
            search: moduleState?.search,
            selectedBreakdownOffice: breakdowns?.selectedBreakdownOffice,
            selectedModule: state.selectedModule,
            selectedBreakdownTab: breakdowns?.selectedBreakdownTab,
            setIsFooterDisabled: state.setIsFooterDisabled,
        });
    });

    const officeId = selectedBreakdownOffice?.officeId;
    const searchCriteria = useRef(search?.searchCriteria);

    useEffect(() => {
        searchCriteria.current = search?.searchCriteria;
    }, [search?.searchCriteria]);

    const fetchData = (additionalParams = []) => {
        setState((state) => ({
            ...state,
            data: { results: [], totals: {}, error: null },
            isLoading: true
        }));
        setIsFooterDisabled(selectedBreakdownTab, true, pathname);

        getAgentBreakdown(searchCriteria.current, additionalParams)
            .then((data) => {
                setStateData('data', data, setState);
                setAgentData(agentData => ({
                    ...agentData,
                    [selectedModule]: {
                        ...agentData?.[selectedModule],
                        agMovAgentBreakdownSearch: data.results
                    }
                }));
            })
            .catch((error) => {
                setStateData('data', { ...state.data, error: error.message || error }, setState);
                console.error(error);
            })
            .finally(() => {
                setStateData('isLoading', false, setState);
                setIsFooterDisabled(selectedBreakdownTab, false, pathname);
            });
    };

    useEffect(() => {
        if (!isOfficeListBreakdown && (!officeId || !searchCriteria.current)) return;

        if (!isOfficeListBreakdown) {
            fetchData([{ parameter: parameterName, value: officeId }]);
        }
    }, [officeId, isOfficeListBreakdown]);

    useEffect(() => {
        if (isOfficeListBreakdown && searchCriteria.current) {
            fetchData([]);
        }
    }, [isOfficeListBreakdown, searchCriteria.current]);

    return state;
}
